import React from "react";
import ColorRelationshipTab, {
  ColorRelationshipConfig,
} from "./ColorRelationshipTab";

const config: ColorRelationshipConfig = {
  relationshipType: "Equivalence",
  labels: {
    addTitle: "Mark Some Colors as Equivalent",
    addButton: "Mark as Equivalent",
    existingTitle: "Existing Equivalences",
    addSuccess: "Equivalences added successfully.",
    addError: "Failed to add equivalences.",
    deleteConfirm: (c1, c2) =>
      `Remove equivalence between "${c1}" and "${c2}"?`,
    deleteAction: "Remove equivalence",
    deleteSuccess: "Equivalence removed.",
  },
};

const EquivalencesTab: React.FC = () => (
  <ColorRelationshipTab config={config} />
);

export default EquivalencesTab;
